// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__29d5w","productName":"Table_productName__2ZlDw"};